// Order Items Action API Types
export type OrderItemActionType =
  | "HOLD"
  | "CANCEL"
  | "UNHOLD"
  | "ADD"
  | "CONFIRM";

// Customer action types from delivery options modal
export type CustomerActionType = "hold" | "cancel" | "confirm" | "buytime";

// Mapping from customer actions to API actions
export const CUSTOMER_ACTION_TO_API_ACTION: Record<
  Exclude<CustomerActionType, "buytime">,
  OrderItemActionType
> = {
  hold: "HOLD",
  cancel: "CANCEL",
  confirm: "CONFIRM",
} as const;

export interface OrderItemActionPayload {
  action: OrderItemActionType;
  items: Array<{
    partId: string;
    quantity: number;
  }>;
}

export interface OrderItemActionResponse {
  success: boolean;
  orderItems: Array<{
    partId: string;
    orderedQuantity: number;
    givenQuantity: number;
    remainingDecisionQuantity: number;
    cancelledQuantity: number;
    holdQuantity: number;
  }>;
}
